import { call, put, takeLatest } from "@redux-saga/core/effects";
// import { ConfigTableParser } from "./ConfigParser";
import { ConfigTableApi } from "./ConfigTableApi";
import { ConfigTableconstant } from "./ConfigTableConstant";


function* getConfigtable({payload}) {

    try {
        yield put({ type: ConfigTableconstant.CONFIG_TABLE_REQUEST });


        const res = yield call(ConfigTableApi.getConfigTable,payload.id.id);


        yield put({
            type: ConfigTableconstant.CONFIG_TABLE_RESPONSE,
            payload: res,
           
        });
    } catch (e) {
        console.log('Error', e);
        yield put({
            type: ConfigTableconstant.CONFIG_TABLE_RESPONSE,
            payload: [],
        });
    }
};


function* UpdateConfigCancelSaga(payload) {

    try {
        yield put({ type: ConfigTableconstant.CONFIG_UPDATE_CANCEL_REQUEST });


        const res = yield call(ConfigTableApi.UpdateConfigCancel,payload);



        yield put({
            type:ConfigTableconstant.CONFIG_UPDATE_CANCEL_RESPONSE ,
            payload:res,
        });
    } catch (e) {
        console.log('Error', e);
        yield put({
            type: ConfigTableconstant.CONFIG_UPDATE_CANCEL_RESPONSE,
            payload:[],
        });
    }
};


export function* registerConfigtableSaga() {
    yield takeLatest(ConfigTableconstant.CONFIG_TABLE_SAGA,getConfigtable);
    yield takeLatest(ConfigTableconstant.CONFIG_UPDATE_CANCEL_SAGA,UpdateConfigCancelSaga);
   
   
}
